import { allEnumValues, CardEntryMethod, CardSchemeId, Currency, Gateway, LanguageCode, TransactionResult, TransactionState, TransactionType, TransactionUserAction, } from '@biteinc/enums';
import { AbstractModelSchema } from './abstract_model_schema.js';
import { servicePrincipalSchema } from './service_principal_schema.js';
export const transactionSchema = {
    displayName: 'transaction',
    type: 'object',
    fields: {
        ...AbstractModelSchema.fields,
        orgId: {
            type: 'mongoId',
            required: true,
            isHidden: true,
            isReadOnly: true,
        },
        siteId: {
            type: 'mongoId',
            required: true,
            isHidden: true,
            isReadOnly: true,
        },
        locationId: {
            type: 'mongoId',
            required: true,
            isHidden: true,
            isReadOnly: true,
        },
        clientId: {
            type: 'mongoId',
            required: true,
            isPermanent: true,
        },
        clientOrderId: {
            type: 'mongoId',
            required: true,
            isPermanent: true,
            // Short term id created on the client
        },
        orderId: {
            type: 'mongoId',
            isPermanent: true,
        },
        originalTransactionId: {
            type: 'mongoId',
            isPermanent: true,
            conditions: [
                {
                    field: 'type',
                    values: [TransactionType.Refund],
                },
            ],
        },
        refunderUserId: {
            type: 'mongoId',
            isReadOnly: true,
            conditions: [
                {
                    field: 'type',
                    values: [TransactionType.Refund],
                },
            ],
        },
        // Set in place of refunderUserId when a Bite service refunded.
        refunderPrincipal: {
            ...servicePrincipalSchema,
            conditions: [
                {
                    field: 'type',
                    values: [TransactionType.Refund],
                },
            ],
        },
        refunderUsername: {
            type: 'keyString',
            isReadOnly: true,
            conditions: [
                {
                    field: 'type',
                    values: [TransactionType.Refund],
                },
            ],
        },
        kioskId: {
            type: 'mongoId',
            isPermanent: true,
        },
        replays: {
            type: 'array',
            elementType: 'object',
            isReadOnly: true,
            fields: {
                amountAuthorized: {
                    type: 'price',
                },
                authCode: {
                    type: 'keyString',
                },
                clientReplayId: {
                    type: 'mongoId',
                },
                errors: {
                    type: 'array',
                    elementType: 'object',
                    isFreeform: true,
                },
                finishedAt: {
                    type: 'timestamp',
                },
                i9nId: {
                    type: 'keyString',
                },
                json: {
                    type: 'object',
                    isFreeform: true,
                },
                result: {
                    type: 'int',
                    values: allEnumValues(TransactionResult),
                },
                startedAt: {
                    type: 'timestamp',
                },
                state: {
                    type: 'int',
                    values: allEnumValues(TransactionState),
                },
                transactionTime: {
                    type: 'timestamp',
                },
            },
        },
        tenders: {
            type: 'array',
            elementType: 'object',
            isReadOnly: true,
            fields: {
                amount: {
                    type: 'price',
                },
                surcharge: {
                    type: 'price',
                },
                cardSchemeId: {
                    type: 'int',
                    values: allEnumValues(CardSchemeId),
                },
                last4: {
                    type: 'keyString',
                },
                posTenderTypeID: {
                    type: 'keyString',
                },
                i9nId: {
                    type: 'keyString',
                },
            },
        },
        gateway: {
            type: 'int',
            values: allEnumValues(Gateway),
            required: true,
            isPermanent: true,
        },
        gatewaySoftwareVersion: {
            type: 'keyString',
            isPermanent: true,
        },
        kioskVersion: {
            type: 'keyString',
            isPermanent: true,
        },
        type: {
            type: 'int',
            values: allEnumValues(TransactionType),
            required: true,
            isPermanent: true,
        },
        amount: {
            type: 'price',
            required: true,
            isPermanent: true,
        },
        startedAt: {
            type: 'timestamp',
            required: true,
            isPermanent: true,
        },
        signatureCheckWasRequired: {
            type: 'bool',
            isPermanent: true,
        },
        userAction: {
            type: 'int',
            values: allEnumValues(TransactionUserAction),
            isPermanent: true,
        },
        finishedAt: {
            type: 'timestamp',
            required: true,
            isPermanent: true,
        },
        state: {
            type: 'int',
            values: allEnumValues(TransactionState),
            required: true,
            isPermanent: true,
        },
        result: {
            type: 'int',
            values: allEnumValues(TransactionResult),
            required: true,
            isPermanent: true,
        },
        cardSchemeId: {
            type: 'int',
            values: allEnumValues(CardSchemeId),
            isPermanent: true,
        },
        isCampusCard: {
            type: 'bool',
            isPermanent: true,
        },
        customCardSchemeName: {
            type: 'keyString',
            isPermanent: true,
            isReadOnly: true,
        },
        cardEntryMethod: {
            type: 'int',
            values: allEnumValues(CardEntryMethod),
            isPermanent: true,
        },
        authCode: {
            type: 'keyString',
            isPermanent: true,
        },
        last4: {
            type: 'keyString',
            isPermanent: true,
        },
        maskPan: {
            type: 'keyString',
            isPermanent: true,
        },
        amountAuthorized: {
            type: 'price',
            isPermanent: true,
        },
        surcharge: {
            type: 'price',
            isPermanent: true,
        },
        cardReference: {
            type: 'keyString',
            isPermanent: true,
        },
        cardHolderName: {
            type: 'keyString',
            isPermanent: true,
        },
        cardHolderEmail: {
            type: 'email',
            isPermanent: true,
        },
        expiry: {
            type: 'keyString',
            isPermanent: true,
        },
        postalCode: {
            type: 'keyString',
            isPermanent: true,
        },
        sequenceNumber: {
            type: 'keyString',
            isPermanent: true,
        },
        currencyCode: {
            type: 'keyString',
            isPermanent: true,
        },
        transactionTime: {
            type: 'timestamp',
            isPermanent: true,
        },
        acquirerResponseCode: {
            type: 'keyString',
            isPermanent: true,
        },
        worldpayLaneId: {
            type: 'keyString',
            isPermanent: true,
        },
        receiptLocale: {
            type: 'keyString',
            isPermanent: true,
        },
        receiptText: {
            type: 'keyString',
            isPermanent: true,
        },
        i9nId: {
            type: 'keyString',
            isPermanent: true,
        },
        identifiedErrorCode: {
            type: 'int',
            isPermanent: true,
        },
        clientVersion: {
            type: 'int',
            isPermanent: true,
        },
        syncedFromGatewayAt: {
            type: 'timestamp',
            isPermanent: true,
        },
        importedFromRejectedTransactionsAt: {
            type: 'timestamp',
            isPermanent: true,
        },
        gatewayJson: {
            type: 'object',
            isFreeform: true,
            isReadOnly: true,
        },
        gatewayCommitJson: {
            type: 'object',
            isFreeform: true,
            isReadOnly: true,
        },
        isReconciliation: {
            type: 'bool',
            isReadOnly: true,
        },
        isTaxExempt: {
            type: 'bool',
            isReadOnly: true,
        },
        json: {
            type: 'object',
            isFreeform: true,
        },
        commitJson: {
            type: 'object',
            isFreeform: true,
            isReadOnly: true,
        },
        paymentsApiVersion: {
            type: 'keyString',
            isReadOnly: true,
            isPermanent: true,
            isHidden: true,
        },
        errors: {
            type: 'array',
            elementType: 'object',
            isFreeform: true,
            isPermanent: true,
        },
        notes: {
            type: 'array',
            elementType: 'object',
            isReadOnly: true,
            fields: {
                username: {
                    type: 'keyString',
                    required: true,
                },
                createdAt: {
                    type: 'timestamp',
                    required: true,
                },
                text: {
                    type: 'shortString',
                    required: true,
                },
            },
        },
    },
};
// Kiosk Transactions are basically uninserted/uninflated transactions that comes from the kiosk
// before they are committed to the database
export const makeGarconKioskTransactionSchema = ({ gateway, type, cardSchemeId, } = {}) => {
    return {
        displayName: 'garconKioskTransaction',
        type: 'object',
        fields: {
            startedAt: {
                type: 'timestamp',
                required: true,
            },
            finishedAt: {
                type: 'timestamp',
                required: true,
            },
            gateway: {
                type: 'int',
                values: gateway ?? allEnumValues(Gateway),
                required: true,
            },
            amount: {
                type: 'int',
                required: true,
            },
            currencyCode: {
                type: 'stringEnum',
                enum: Currency,
                required: true,
            },
            clientId: {
                type: 'mongoId',
                required: true,
            },
            type: {
                type: 'int',
                values: type ?? allEnumValues(TransactionType),
                required: true,
            },
            amountAuthorized: {
                type: 'int',
                required: true,
            },
            userAction: {
                type: 'int',
                values: allEnumValues(TransactionUserAction),
                required: true,
            },
            state: {
                type: 'int',
                values: allEnumValues(TransactionState),
                required: true,
            },
            result: {
                type: 'int',
                values: allEnumValues(TransactionResult),
                required: true,
            },
            transactionTime: {
                type: 'timestamp',
                required: true,
            },
            cardEntryMethod: {
                type: 'int',
                values: allEnumValues(CardEntryMethod),
                required: true,
            },
            cardSchemeId: {
                type: 'int',
                values: cardSchemeId ?? allEnumValues(CardSchemeId),
                required: true,
            },
            last4: {
                type: 'keyString',
            },
            clientOrderId: {
                type: 'mongoId',
                required: true,
            },
            acquirerResponseCode: {
                type: 'keyString',
            },
            authCode: {
                type: 'keyString',
            },
            cardHolderName: {
                type: 'keyString',
            },
            cardReference: {
                type: 'keyString',
            },
            errors: {
                type: 'array',
                elementType: 'object',
                isFreeform: true,
            },
            expiry: {
                type: 'keyString',
            },
            i9nId: {
                type: 'keyString',
            },
            json: {
                type: 'object',
                isFreeform: true,
            },
            maskPan: {
                type: 'keyString',
            },
            receiptText: {
                type: 'keyString',
            },
            receiptLocale: {
                type: 'stringEnum',
                enum: LanguageCode,
            },
        },
    };
};
//# sourceMappingURL=transaction_schema.js.map